import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';
import { Transformation } from './transformation';

/**
 * Configuration for a DataMapper task — transforms the current data payload by applying
 * field-level transformation rules. Each rule reads from one or more source fields,
 * optionally applies a chain of transform functions or a custom script, and writes the
 * result to a single destination field. The output payload contains only the explicitly
 * mapped destination fields.
 */
export class DataMapperConfig extends DestinationTaskConfigBase {
	/**
	 * Ordered list of transformation rules to execute. Each transformation maps one or more
	 * source field paths to a single destination field, with optional type conversion,
	 * string/math operations, or a custom JavaScript script.
	 * Transformations are executed in ascending `index` order.
	 */
	transformations: Transformation[] = [];

	constructor(init?: Partial<DataMapperConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
